export class ClearState {
    static readonly type = '[Session End] clear';
    constructor() {}
}
